// extracted by mini-css-extract-plugin
module.exports = {"indexMain":"IndexMain2_indexMain__VulEv"};